import { getEcCom } from '../util/convert';

class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            loadedLocaleProvider: false
        }
    }
    componentWillMount() {
        const { WeaLocaleProvider } = getEcCom();
        WeaLocaleProvider.getLocaleLabel("workflowForm", null, null, ()=> {
            this.setState({ loadedLocaleProvider: true })
        })
    }
    render() {
        const { WeaLocaleProvider } = getEcCom();
        const { loadedLocaleProvider } = this.state;

        return (
            <div style={{ height: "100%" }}>
                {loadedLocaleProvider && <WeaLocaleProvider ecId={`${this && this.props && this.props.ecId || ''}_WeaLocaleProvider@uf3vn2`}>
                    {this.props.children}
                </WeaLocaleProvider>
                }
            </div>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/Home.js